import { render } from "./blogByCategory.vue?vue&type=template&id=812cea40&scoped=true"
import script from "./blogByCategory.vue?vue&type=script&lang=js"
export * from "./blogByCategory.vue?vue&type=script&lang=js"

import "./blogByCategory.vue?vue&type=style&index=0&id=812cea40&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-812cea40"]])

export default __exports__